import {
  DataChangeLogTableFragment,
  DataChangeLogTableFragmentDoc,
  getDataChangeLogsDocument,
  getDataChangeLogsTotalDocument,
} from '../../graphql/api/generated';
import { PermissionKey_enum } from '../../graphql/hasura/generated';
import { useMainApiTableData } from '../../hooks/useTableManager';
import * as apColumns from '../AccessPoint/columns';

import { changedAtColumn, changedByUserColumn, createBeforeAndAfterColumns } from './columns';
import model from './model';

const commonTableConfig = {
  useTableData: useMainApiTableData({
    totalOperation: getDataChangeLogsTotalDocument,
    listOperation: getDataChangeLogsDocument,
  }),
  fragment: DataChangeLogTableFragmentDoc, // @TODO: Not used, but required by config
  csvExportEnabled: false,
};

const commonColumns = [
  changedByUserColumn,
  changedAtColumn,
];

const accessPointColumns = createBeforeAndAfterColumns({
  property: apColumns.propertyColumn,
  name: apColumns.nameColumn,
  image: apColumns.imageColumn,
  type: apColumns.typeColumn,
  maxOccupancy: apColumns.maxOccupancyColumn,
  accessTimeout: apColumns.accessTimeoutColumn,
  rexAccessTimeout: apColumns.rexAccessTimeoutColumn,
  timetable: apColumns.scheduleColumn,
  spaceshipModeEnabled: apColumns.spaceshipModeEnabledDetailsColumn,
  proximityRestriction: apColumns.proximityRestrictionDetailsColumn,
  dpsAlertDelay: apColumns.dpsAlertDelayColumn,
  dpsAlertInterval: apColumns.dpsAlertIntervalColumn,
  mapLocation: apColumns.mapLocationChangedColumn,
  archivedAt: apColumns.archivedAtChangedColumn,
});

export const AccessPointDataChangeLogsByPkTable = model.createTable<DataChangeLogTableFragment>({
  title: 'History of Changes',
  ...commonTableConfig,
  enabled: ({ hasPermission }) => hasPermission(PermissionKey_enum.AccessPoint_Read),
  fixedQueryFilters: (targetDataId: string) => ({
    targetDataId,
    tableName: 'AccessPoint',
  }),
  defaultOrderBy: { changedAt: 'descend' },
  columns: [
    ...accessPointColumns,
    ...commonColumns,
  ],
});
